import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSort } from '@angular/material/sort';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { BannerElement, UpdateBannerPayload } from './www-banner-list.model';
import { WwwBannerApiService } from '../www-banner-api/www-banner.api.service';
import { catchError, from } from 'rxjs';
import { Result } from '@/reservation/reservation.model';

@Component({
	selector: 'app-www-banner-list',
	templateUrl: './www-banner-list.component.html',
})
export class WwwBannerListComponent implements OnInit {
	@ViewChild('dataTable') table: MatTable<BannerElement>;
	@ViewChild(MatSort) sort: MatSort;

	displayedColumns: string[] = ['id', 'url', 'name', 'status', 'link', 'edit'];

	data: MatTableDataSource<BannerElement> = new MatTableDataSource<BannerElement>();

	constructor(
		private readonly infobox: InfoboxService,
		private readonly wwwBannerApiService: WwwBannerApiService,
	) {}

	ngOnInit(): void {
		this.refreshBanners();
	}

	dropTable(event: CdkDragDrop<BannerElement[]>): void {
		moveItemInArray(this.data.data, event.previousIndex, event.currentIndex);
		this.table.renderRows();
	}

	save() {
		const mappedPromises = this.batchUpdateBanners();

		from(mappedPromises)
			.pipe(
				catchError((err) => {
					this.refreshBanners();
					return err;
				}),
			)
			.subscribe(() => {
				this.infobox.success('Zapisano');
			});
	}

	private batchUpdateBanners(): Promise<BannerElement[]> {
		return Promise.all(
			this.data.data
				.filter((element, id) => element.order !== id)
				.map((element, id) => {
					const payload: UpdateBannerPayload = {
						...element,
						order: id,
						multimedia: element.multimedia.id,
						multimediaMobile: element.multimediaMobile?.id ?? null,
					};

					return this.wwwBannerApiService.updateBanner(payload);
				}),
		);
	}

	private refreshBanners(): void {
		from(this.wwwBannerApiService.getBanners()).subscribe((result: Result<BannerElement>) => {
			this.data.data = result.results.map((obj) => ({
				...obj,
				url: obj.multimedia.url,
				status: obj.isActive ? 'Aktywny' : 'Niekaktywny',
			}));
		});
	}
}
